import styled, { css } from 'styled-components';

import {
    Flex,
    Text,
    Table,
    IconZillowLogo,
    mediaMixin,
    spaceMixin,
    token,
} from '@zillow/constellation';

import MediumIllustrationHouse2x from 'app/shared/images/MediumIllustrationHouse@2x.png';

// vars
const THEME_VALIDATION = 'props => props.theme && props.theme.ns';
const IMAGE = {
    WIDTH: 136, // max-width of image
    HEIGHT: 88, // max-height of image
};
const CELL = {
    WIDTH: 200, // max-width of cell
    HEIGHT: 96, // min-height of cell
};
const HIDDEN_TEXT = `
    /* bypass the need for text to properly align */
    &:before {
        content: "hidden";
        display: flex;
        height: 0px;
        font-size: 0px;
    }
`;

export const StyledPropertyPhotoContainer = styled.div`
    display: flex;
    max-width: ${IMAGE.WIDTH + 32}px;
    min-height: ${IMAGE.HEIGHT}px;
    align-items: center;
    justify-content: center;

    ${HIDDEN_TEXT}
`;

export const StyledPropertyPhoto = styled.div`
    width: ${IMAGE.WIDTH}px;
    height: ${IMAGE.HEIGHT}px;
    margin: 0 auto;

    background-repeat: no-repeat;
    background-position: center center;
    background-size: ${props => (props.primaryPhotoUrl ? 'cover' : '100px')};
    background-image: url(${props => (props.primaryPhotoUrl ? props.primaryPhotoUrl : MediumIllustrationHouse2x)});

    ${props => THEME_VALIDATION && css`
        background-color: ${props.primaryPhotoUrl ? '#888' : token('colors.blue200')};
    `}
`;

export const StyledFlexContainer = styled(Flex)`
    display: flex;
    align-items: center;
    min-height: ${CELL.HEIGHT}px;
    max-width: ${CELL.WIDTH}px;

    ${HIDDEN_TEXT}
`;

export const StyledPropertyAddress = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    /* IE11 support */
    min-height: ${props => (props.isMultifamily ? spaceMixin(9) : spaceMixin(6))};

    ${props => props.marginTop && css`
        margin-top: ${spaceMixin(1)};
    `}

    > * {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const StyledPropertyRow = styled(Table.Row)`
    cursor: pointer;
`;

export const StyledPropertyText = styled(Text)`
    max-width: ${props => (props.isAddress ? CELL.WIDTH + 50 : CELL.WIDTH)}px;

    ${props => props.marginLeft && css`
        margin-left: 3px;
    `}
`;

export const StyledTagWrapper = styled.div`
    width: 100%;
`;

export const StyledIconZillowLogo = styled(IconZillowLogo)`
    margin: -4px 2px 0 0;
`;

export const StyledTableCell = styled(Table.Cell)`
    && {
        ${mediaMixin('md', css`
            padding: 16px 0 16px 16px;

            &:last-child {
                padding-right: 16px;
            }
        `)}

        ${mediaMixin('xl', css`
            padding: 16px;
        `)}
    }

    ${props => props.isMinWidthNeeded && css`
        min-width: ${CELL.WIDTH}px;
    `}
`;
